import { getConfig } from '@atlassian/atlassian-studio-common';

export const buildStudioAccountSyncLoginUrl = (
	currentPageHref: string,
	loginHintEmail: string,
): string => {
	// Delete login_hint from the continue URL to avoid infinite loop.
	const continueUrl = new URL(currentPageHref);
	continueUrl.searchParams.delete('login_hint');

	const identityBaseUrl = getConfig().atlassianAccountUrl;
	// Set up the login URL parameters for syncing the account.
	const params = new URLSearchParams();
	params.set('application', 'studio');
	params.set('continue', continueUrl.toString());
	params.set('prompt', 'none');
	params.set('login_hint', loginHintEmail.trim());
	return `${identityBaseUrl}/login?${params.toString()}`;
};

export const redirectToLogin = (): void => {
	const href = window.location.href;
	const loginUrl = `${getConfig().atlassianAccountUrl}/login?continue=${encodeURIComponent(href)}`;
	window.location.href = loginUrl;
};
